import { render, staticRenderFns } from "./tabDocs.vue?vue&type=template&id=11cc7432&"
import script from "./tabDocs.vue?vue&type=script&lang=js&"
export * from "./tabDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports